import gql from 'graphql-tag';
import PICK_LIST_FRAGMENT_FOR_SERVICE_DOCKET from './PICK_LIST_FRAGMENT_FOR_SERVICE_DOCKET';

const SERVICE_DOCKET_FRAGMENT = gql`
	fragment serviceDocketDetails on ServiceDocket {
		id
		date
		planned
		machineServiceType
		machineRestockType
		inventoryCheck
		restockRevision
		replacementReviewRequired
		replacementReviewReason
		replacementReviewFlaggedAt
		pickListGenerationStatus
		status
		manualRestock
		isRestocked
		startedProcessing
		manualRestockApprovedBy {
			id
			firstname
			lastname
		}
		manualRestockComment
		pickList {
			...pickList
		}
		stockCheckItems {
			...stockLevelItem
		}

		checkedProductExpirySchedules {
			id
			name
			status
			type

			startsAt
			repeatInterval
			maxCheckedProducts
			adaptiveExpiryChecksEnabled

			posType

			applyToAllProducts
			selectedProducts {
				id
				name
				tags {
					id
					name
				}
			}
			filterProductsBy
			noProductExclusion
			excludedProducts {
				id
				name
				tags {
					id
					name
				}
			}
			productTags {
				id
				name
			}
			excludedProductTags {
				id
				name
			}
			applyToAllProductTags
			noProductTagExclusion
			freshFoodOption

		}

		productExpiryCheckSchedules {
			id
			name
			status
			type

			startsAt
			repeatInterval
			maxCheckedProducts
			adaptiveExpiryChecksEnabled

			posType

			applyToAllProducts
			selectedProducts {
				id
				name
				tags {
					id
					name
				}
			}

			noProductExclusion
			excludedProducts {
				id
				name
				tags {
					id
					name
				}
			}

			filterProductsBy

			productTags {
				id
				name
			}

			excludedProductTags {
				id
				name
			}
			applyToAllProductTags
			noProductTagExclusion
			freshFoodOption
		}

		machine {
			id
			type
			isOffline
			assetId
			place {
				id
				name
				directions
				visualDirectionPhotos {
					id
					link
					comment
				}
				visualDirectionPhotoUrls
			}
			overrideRestrictedProductTags
			restrictedProductTags {
				id
			}
			location {
				id
				name
				directions
				requiresSignIn
				signInInstructions
				visualDirectionPhotos {
					id
					link
					comment
				}
				visualDirectionPhotoUrls
				restrictedProductTags {
					id
				}
			}
			planogram {
				id
				items {
					id
					created
					row
					column
					planogramItemGroupId
				}
				planogramItemGroups {
					id
					name
					type
					order
					layoutSettings
				}
			}
			usesDynamicParlevels
			dynamicParlevelsSettings
			averageDaysSinceLastService
			planogramItemsVendRate
		}

		serviceRun {
			id
			restockType
			driver {
				id
				firstname
				lastname
				destroyed
			}
			route {
				id
				name
			}
			planned
		}
	}${PICK_LIST_FRAGMENT_FOR_SERVICE_DOCKET}
`;

export default SERVICE_DOCKET_FRAGMENT;
